import styled from 'styled-components';
import theme from '../theme';

export const StyledClearButtonWrapper = styled.div<{ $showButton: boolean }>`
  display: inline-block;
  width: 14px;
  margin: auto auto auto 5px;
  height: 100%;
  ${({ $showButton }) => !$showButton && 'display: none'};
  > button {
    display: inline-grid;
    background: ${theme.gray6};
    border-radius: 50%;
    opacity: 0;
    transition: all 0.5s;
  }
`;

export const StyledRadioWrapper = styled.label<{
  $showButton: boolean;
  $justify: string;
  $fullWidth?: boolean;
}>`
  position: relative;
  display: flex;
  ${({ $fullWidth }) => `width: ${$fullWidth ? '100%' : 'fit-content'};`}
  ${({ $justify }) => $justify && `justify-content: ${$justify}`};
  &:hover {
    ${StyledClearButtonWrapper} > button {
      ${({ $showButton }) => $showButton && 'opacity: 1'};
    }
  }
`;
